import { Component, OnInit } from '@angular/core';
import {StaffFormDialog} from "@ft/core";

@Component({
  selector: 'ftb-billing-staff-dialog',
  templateUrl: './billing-staff-dialog.component.html',
})
export class BillingStaffDialogComponent extends StaffFormDialog {
}
